// src/schemas/custom-components.ts
import { Type } from "@sinclair/typebox";
var TextSpaceAfterPropsSchema = Type.Object({
  content: Type.String({
    description: "Text content (required)"
  }),
  spaceAfter: Type.Optional(
    Type.Number({
      minimum: 0,
      description: "Spacing after text in points"
    })
  ),
  fontSize: Type.Optional(Type.Number({ minimum: 1 })),
  fontFamily: Type.Optional(Type.String()),
  bold: Type.Optional(Type.Boolean()),
  fontWeight: Type.Optional(Type.Integer({ minimum: 100, maximum: 900 })),
  italic: Type.Optional(Type.Boolean()),
  underline: Type.Optional(Type.Boolean()),
  color: Type.Optional(
    Type.String({
      pattern: "^#[0-9A-Fa-f]{6}$"
    })
  ),
  alignment: Type.Optional(
    Type.Union([
      Type.Literal("left"),
      Type.Literal("center"),
      Type.Literal("right"),
      Type.Literal("justify")
    ])
  )
});
var TextSpaceAfterComponentSchema = Type.Object({
  name: Type.Literal("text-space-after"),
  id: Type.Optional(Type.String()),
  props: TextSpaceAfterPropsSchema
});
var CustomComponentDefinitionSchema = TextSpaceAfterComponentSchema;

export {
  TextSpaceAfterPropsSchema,
  TextSpaceAfterComponentSchema,
  CustomComponentDefinitionSchema
};
//# sourceMappingURL=chunk-7GGTZ4TA.js.map